import { LcFilterListName } from '../enums/lc-filter-list.enum';

export const CONTAINERS_COMPONENT_NAME = LcFilterListName.legalChanges;
export const LEGAL_REGISTER_COMPONENT_NAME = LcFilterListName.legalRegister;
export const REQUIREMENTS_COMPONENT_NAME = LcFilterListName.requirements;
